export default __webpack_public_path__ + "static/media/back_sura.52a23bbe.svg";